import Fuse from 'fuse.js';
import { ConversationMemberView } from '@mark43/cad-api';

export class RecipientSearch {
    fuse: Fuse<ConversationMemberView>;

    constructor(searchItems: ConversationMemberView[]) {
        this.fuse = new Fuse(searchItems, {
            keys: ['label'],
            threshold: 0.1,
            ignoreLocation: true,
        });
    }

    search(searchText: string): ConversationMemberView[] {
        return this.fuse.search(searchText).map((result) => result.item);
    }
}
